import { AccordionProps } from 'Types/Presentation/Components/Accordion'

const Accordion: React.FC<AccordionProps> = ({
	defaultShow,
	id,
	title,
	children,
	additonalClasses,
}) => {
	return (
		<div className={`accordion ${additonalClasses ?? ''}`} id={id}>
			<div className="accordion-item">
				<h2 className="accordion-header" id={`${id}_header_1`}>
					<button
						className={`accordion-button fs-4 fw-bold ${defaultShow ? '' : 'collapsed'}`}
						type="button"
						data-bs-toggle="collapse"
						data-bs-target={`#${id}_body_1`}
						aria-expanded={defaultShow ? 'true' : 'false'}
						aria-controls={`${id}_body_1`}>
						{title}
					</button>
				</h2>
				<div
					id={`${id}_body_1`}
					className={`accordion-collapse collapse ${defaultShow ? 'show' : ''}`}
					aria-labelledby={`${id}_header_1`}
					data-bs-parent={`#${id}`}>
					<div className="accordion-body">{children}</div>
				</div>
			</div>
		</div>
	)
}

export default Accordion
